// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.mapContainer{

  width: 100%; 
  height: 100%; 

}

.mapContainer1{
  border-radius: 5px;
  width: 100%; 
  height: 40vh!important; 
  border: 1px 
  solid #c0c0c0 !important;
}

.mapContainer2{
  border-radius: 5px;
  width: 100%; 
  height: 40vh!important; 
  border: 1px 
  solid #c0c0c0 !important;
}

.mapContainer3{
  
  border-radius: 5px;
  width: 100%; 
  height: 40vh!important; 
  border: 1px 
  solid #c0c0c0 !important;
}

.mapContainerCard{
overflow: visible;
width:  100%; 
height: 100%;
padding: 5px; 
border: 10px; 
}

.leaflet-containerCard{
  overflow: visible;
  width:  80%; 
  height: 100%;
  padding: 5px; 
  border: 0px 
}

.popupText {
    font-family: Aldrich;
    text-align: left;
    font-size: 0.6rem;
  }

  .popupText1 {
    font-family: Aldrich;
    text-align: left;
    font-size: 0.6rem;
  }

.leaflet-div-icon {
    background: transparent !important;
    border: none !important;
	  color:#1ed12d !important;
  }

.leaflet-div-icon3
  {
      background: #DC3545 !important;
      border:5px solid rgba(255,255,255,0.5) !important;
      color:#007BFF !important;
      font-weight:bold !important;
      text-align:center !important;
      border-radius:50% !important;
      line-height:30px !important;
  }

  .leaflet-popup {
    margin-bottom: 0px !important;
    }

    .leaflet-popup-tipRed{
      color: #DC3545;
      Width: 90;
    }

    .leaflet-popup-tipBlue{
      color:#007BFF;
      Width: 90;
    }
`, "",{"version":3,"sources":["webpack://./src/assets/css/maps.css"],"names":[],"mappings":";;;AAGA;;EAEE,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB;0BACwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB;0BACwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB;0BACwB;AAC1B;;AAEA;AACA,iBAAiB;AACjB,YAAY;AACZ,YAAY;AACZ,YAAY;AACZ,YAAY;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;EACnB;;AAEF;IACI,kCAAkC;IAClC,uBAAuB;GACxB,wBAAwB;EACzB;;AAEF;;MAEM,8BAA8B;MAC9B,iDAAiD;MACjD,wBAAwB;MACxB,2BAA2B;MAC3B,4BAA4B;MAC5B,4BAA4B;MAC5B,2BAA2B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B;;IAEA;MACE,cAAc;MACd,SAAS;IACX;;IAEA;MACE,aAAa;MACb,SAAS;IACX","sourcesContent":["\n\n\n.mapContainer{\n\n  width: 100%; \n  height: 100%; \n\n}\n\n.mapContainer1{\n  border-radius: 5px;\n  width: 100%; \n  height: 40vh!important; \n  border: 1px \n  solid #c0c0c0 !important;\n}\n\n.mapContainer2{\n  border-radius: 5px;\n  width: 100%; \n  height: 40vh!important; \n  border: 1px \n  solid #c0c0c0 !important;\n}\n\n.mapContainer3{\n  \n  border-radius: 5px;\n  width: 100%; \n  height: 40vh!important; \n  border: 1px \n  solid #c0c0c0 !important;\n}\n\n.mapContainerCard{\noverflow: visible;\nwidth:  100%; \nheight: 100%;\npadding: 5px; \nborder: 10px; \n}\n\n.leaflet-containerCard{\n  overflow: visible;\n  width:  80%; \n  height: 100%;\n  padding: 5px; \n  border: 0px \n}\n\n.popupText {\n    font-family: Aldrich;\n    text-align: left;\n    font-size: 0.6rem;\n  }\n\n  .popupText1 {\n    font-family: Aldrich;\n    text-align: left;\n    font-size: 0.6rem;\n  }\n\n.leaflet-div-icon {\n    background: transparent !important;\n    border: none !important;\n\t  color:#1ed12d !important;\n  }\n\n.leaflet-div-icon3\n  {\n      background: #DC3545 !important;\n      border:5px solid rgba(255,255,255,0.5) !important;\n      color:#007BFF !important;\n      font-weight:bold !important;\n      text-align:center !important;\n      border-radius:50% !important;\n      line-height:30px !important;\n  }\n\n  .leaflet-popup {\n    margin-bottom: 0px !important;\n    }\n\n    .leaflet-popup-tipRed{\n      color: #DC3545;\n      Width: 90;\n    }\n\n    .leaflet-popup-tipBlue{\n      color:#007BFF;\n      Width: 90;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
